<h2 mat-dialog-title>Add Search Terms</h2>
<mat-dialog-content style="width: 540px; height: 250px; padding: 4px 10px 20px; margin: 0;">
  <div style="display: flex; flex-direction: column;">
    <mat-form-field class="density-neg-4 show-no-errors">
      <textarea matInput [(ngModel)]="queryString" placeholder="Add one term per line using OpenSearch syntax..." rows="11"></textarea>
    </mat-form-field>
    @if (hasInvalidQueryString || hasDuplicateQueryString) {
      <mat-error>
        <p *ngIf="hasInvalidQueryString">
          Queries can not be more than 2000 characters
        </p>
        <br />
        <p *ngIf="hasDuplicateQueryString">
          Can not have duplicate query strings
        </p>
      </mat-error>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" (click)="ok()">Add</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
